import { useMediaQuery } from "@mui/material";
import { tabletQuery } from "../config";

export function useIsTablet() {
	return useMediaQuery(tabletQuery);
}
